import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const boardSegmentTilesStyleId = 'wb-v2-board-segment-tiles-theme';

const boardSegmentHostStyles = {
  '--local-segment-font-family': tokens.font.family.body,
  '--local-segment-row-padding': tokens.spacing.lg,
  '--local-segment-row-border': tokens.color.border.secondary,
  '--local-segment-progress': tokens.color.foreground.brandSecondary,

  // Tiles (stacked label over count).
  '--local-segment-tile-gap': tokens.spacing.lg,
  '--local-segment-tile-padding-y': tokens.spacing.md,
  '--local-segment-tile-padding-x': tokens.spacing.lg,
  '--local-segment-tile-bg': tokens.color.background.primary,
  '--local-segment-tile-border': tokens.color.border.secondary,
  '--local-segment-tile-active-border': tokens.color.border.brand,
  '--local-segment-tile-radius': tokens.radius.md,
  '--local-segment-tile-label-gap': tokens.spacing.md,
  '--local-segment-tile-label-size': tokens.font.size.textSm,
  '--local-segment-tile-label-color': tokens.color.text.secondary,
  '--local-segment-tile-count-family': tokens.font.family.display,
  '--local-segment-tile-count-size': tokens.font.size.textLg,
  '--local-segment-tile-count-weight': tokens.font.weight.semibold,
  '--local-segment-tile-count-line-height': tokens.lineHeight.textLg,
  '--local-segment-tile-count-color': tokens.color.text.tertiary,
  '--local-segment-tile-count-ready-color': tokens.color.text.primary,

  // Pills (single line: dot + label + inline count).
  '--local-segment-pill-gap': tokens.spacing.md,
  '--local-segment-pill-padding-y': tokens.spacing.sm,
  '--local-segment-pill-padding-x': tokens.spacing.lg,
  '--local-segment-pill-bg': tokens.color.background.primary,
  '--local-segment-pill-border': tokens.color.border.secondary,
  '--local-segment-pill-border-width': tokens.borderWidth.sm,
  '--local-segment-pill-radius': tokens.radius.full,
  '--local-segment-pill-hover-bg': tokens.color.background.primaryHover,
  // Active carries a brand tint AND a brand border — at pill scale a 1px edge alone is too
  // weak to locate, and the active pill must stay identifiable when it is the only one in view.
  '--local-segment-pill-active-bg': tokens.color.background.brandPrimary,
  '--local-segment-pill-active-border': tokens.color.border.brand,
  '--local-segment-pill-active-text': tokens.color.text.primary,
  '--local-segment-pill-active-count': tokens.color.text.brandSecondary,
  '--local-segment-pill-text': tokens.color.text.secondary,
  '--local-segment-pill-font-size': tokens.font.size.textSm,
  '--local-segment-pill-line-height': tokens.lineHeight.textSm,
  '--local-segment-pill-label-weight': tokens.font.weight.medium,
  '--local-segment-pill-count-weight': tokens.font.weight.semibold,
  '--local-segment-pill-count-color': tokens.color.text.tertiary,
  '--local-segment-pill-count-ready-color': tokens.color.text.primary,
  // A zero count is information ("no errors"), so it is muted rather than hidden.
  '--local-segment-pill-count-zero-color': tokens.color.text.quaternary,
  '--local-segment-pill-scrollbar': tokens.color.border.secondary,
  // Compact overrides applied by the component's @container rule on a narrow BOARD.
  '--local-segment-pill-compact-gap': tokens.spacing.sm,
  '--local-segment-pill-compact-padding-x': tokens.spacing.md,
};

const boardSegmentCompactStyles = {
  '--local-segment-row-padding': tokens.spacing.sm,
  '--local-segment-tile-gap': tokens.spacing.sm,
  '--local-segment-tile-padding-y': tokens.spacing.xs,
  '--local-segment-tile-padding-x': tokens.spacing.sm,
  '--local-segment-tile-label-gap': tokens.spacing.xs,
  '--local-segment-tile-label-size': tokens.font.size.textSm,
  '--local-segment-tile-count-size': tokens.font.size.textSm,
  '--local-segment-tile-count-line-height': tokens.lineHeight.textSm,
  '--local-segment-pill-gap': tokens.spacing.sm,
  '--local-segment-pill-padding-y': tokens.spacing.xs,
  '--local-segment-pill-padding-x': tokens.spacing.sm,
  '--local-segment-pill-radius': tokens.radius.sm,
  '--local-segment-pill-font-size': tokens.font.size.textSm,
  '--local-segment-pill-line-height': tokens.lineHeight.textSm,
  '--local-segment-pill-compact-gap': tokens.spacing.xs,
  '--local-segment-pill-compact-padding-x': tokens.spacing.sm,
};

export const boardSegmentTilesBridgeStyles = {
  'board-segment-tiles': boardSegmentHostStyles,
  'board-view-pills': boardSegmentHostStyles,
  'board-segment-tiles[data-size="compact"]': boardSegmentCompactStyles,
  'board-view-pills[data-size="compact"]': boardSegmentCompactStyles,
};
